export enum BookingType {
  BAGS = 'bags',
  EXTRAS = 'extras',
  MEALS = 'meals',
  SEATS = 'seats',
  GENERIC = 'generic',
  INVALID = 'invalid'
}
